<!-- file-upload.component.html -->
<div class="file-upload-container">
    <div class="file-upload-container">
        <div class="upload-area">
            <img src="../assets/icons/backup.svg" alt="upload" class="upload-icon">
            <div class="upload-text">
                <p>Drag your file(s) or <span class="browse-text">browse</span></p>
                <p class="file-limit">Max 10 MB files are allowed</p>
            </div>
            <input type="file" [accept]="acceptedTypes" (change)="onFileSelected($event)" class="file-input"
                [disabled]="isUploading || files?.length == mediaCount || isDisable" multiple>
        </div>
        @if(errorMessage){
        <div class="err text-danger small">
            <span>{{errorMessage}}</span>
        </div>
        }
    </div>

    <!-- Support Info -->
    <p class="image-required-desc mt-2 mb-2">Only support .jpg, .png and .jpeg</p>


    <!-- File List -->
    <div class="file-list" *ngIf="files.length > 0">
        @for(fileItem of files; track $index){
        @if(!fileItem?.error){
        <div class="file-item">
            <!-- {{fileItem!.progress}} -->
            @if(fileItem!.progress < 100){ <div class="uploaded-file">
                <div class="file-content">
                    <i class="pi pi-file"></i>
                    <div class="file-info">
                        <h1>{{fileItem?.fileName}} </h1>
                    </div>
                </div>
                <div class="progress-bar-container">
                    <p-progressbar [value]="fileItem?.progress" />
                    <span class="progress-label"> {{fileItem?.progress}}% </span>
                </div>
        </div>
        }@else{
        <div class="uploaded-file d-flex align-items-center justify-content-between">
            <div class="file-content">
                @if(fileItem?.type == 'video'){
                    <!-- <video class="uploaded-img" width="100%" controls>
                        <source [src]="fileItem?.image" type="video/mp4">
                    </video> -->
                    <i class="pi pi-video"></i>
                }@else{
                <img class="uploaded-img" [src]="fileItem?.image" alt="">
                }
                <div class="file-info">
                    <h1> {{fileItem?.fileName}} </h1>
                    <span> {{fileItem?.fileSize}} </span>
                </div>
            </div>
            @if(fileItem?.status !== 'loadingDelete'){
            <i class="pi pi-times-circle cursor-pointer" (click)="clearImg(fileItem)"></i>
            }@else{
            <i class="pi pi-spin pi-spinner"></i>
            }
        </div>
        }
    </div>
    }@else{
    <div class="uploaded-file d-flex align-items-center justify-content-between">
        <div class="file-content">
            <img class="uploaded-img" [src]="fileItem?.image" alt="">
            <div class="file-info">
                <h1> {{fileItem?.fileName}} </h1>
                <span class="text-danger"> Upload Failed </span>
            </div>
        </div>
        <div class="d-flex align-items-center gap-2">
            @if(fileItem?.status !== 'loadingDelete'){
            <i class="pi pi-times-circle cursor-pointer" (click)="clearImg(fileItem)"></i>
            }@else{
            <i class="pi pi-spin pi-spinner"></i>
            }
            @if(fileItem?.status !== 'reUploading'){
            <img src="../../../../assets/images/repeat.svg" alt="" class="cursor-pointer"
                (click)="uploadFile(fileItem,true)">
            }@else{
            <i class="pi pi-spin pi-spinner"></i>
            }
        </div>
    </div>
    }
    }
</div>


</div>